import { Component } from '@angular/core';

@Component({
  selector: 'app-news',
  standalone: false,
  templateUrl: './news.html',
  styleUrl: './news.css'
})
export class News {

}
